import EmployeeDocumentActions from './EmployeeDocumentActions.component';

export default EmployeeDocumentActions;
